import { render, staticRenderFns } from "./ApiPortal.vue?vue&type=template&id=49e842c6&scoped=true"
import script from "./ApiPortal.vue?vue&type=script&lang=js"
export * from "./ApiPortal.vue?vue&type=script&lang=js"
import style0 from "./ApiPortal.vue?vue&type=style&index=0&id=49e842c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e842c6",
  null
  
)

export default component.exports